import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../auth/ProtectedRoute";
import { User } from "../models/User";
import PageNotFound from "../pages/404";
import ClaimsList from "../pages/ClaimsList";
import Dashboard from "../pages/Dashboard";
import DashboardAdmin from "../pages/DashboardAdmin";
import NewMail from "../pages/NewMail";
import Search from "../pages/Search";

interface AppRoutesProps {
  user: User;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ user }) => (
  <Routes>
    <Route
      element={
        <ProtectedRoute
          isAllowed={user.isSuperAdmin || user.isAdmin}
          redirectPath="/claim"
        />
      }
    >
      <Route path="/admin" element={<DashboardAdmin user={user} />} />
    </Route>

    <Route
      element={
        <ProtectedRoute isAllowed={user.isOperator} redirectPath="/" />
      }
    >
      <Route path="/claim" element={<Dashboard user={user} />} />
      <Route path="/claim/newmail" element={<NewMail />} />
      <Route
        path="/claims/search"
        element={<Search showExtraActions={user.isAdmin} />}
      />
      <Route path="/claims" element={<ClaimsList />} />
      <Route path="/claims/:id" element={<Dashboard user={user} />} />
    </Route>

    <Route path="*" element={<PageNotFound user={user} />} />
  </Routes>
);

export default AppRoutes;
